<template>
    <div>
        <h2>Create voucher codes</h2>

        <p>
            Press the button to add 100 new voucher codes to the database.
        </p>

        <form @submit.prevent="submitForm">
            <b-dropdown id="type-select" :text="selectedTypeStr || 'Select subscription type'"
                class="m-md-2">
                <b-dropdown-item @click="selectedType = 'test'; selectedTypeStr = 'Test'">Test</b-dropdown-item>
                <b-dropdown-item @click="selectedType = 'free'; selectedTypeStr = 'Free'">Free</b-dropdown-item>
                <b-dropdown-item @click="selectedType = 'plus'; selectedTypeStr = 'Plus'">Plus</b-dropdown-item>
                <b-dropdown-item @click="selectedType = 'ai'; selectedTypeStr = 'AI'">AI</b-dropdown-item>
                <b-dropdown-item @click="selectedType = 'plusai'; selectedTypeStr = 'Plus and AI'">Plus &amp; AI</b-dropdown-item>

                <b-dropdown-item v-for="elem in additionalTypes" v-bind:key="'create-' + elem" @click="selectedType = elem; selectedTypeStr = elem;">{{ elem }}</b-dropdown-item>
            </b-dropdown>
            <b-dropdown id="duration-select" :text="selectedDurationStr || 'Select subscription duration (days)'"
                class="m-md-2">
                <b-dropdown-item @click="selectedDuration = 7; selectedDurationStr = 'Week'">Week</b-dropdown-item>
                <b-dropdown-item @click="selectedDuration = 30; selectedDurationStr = 'Month'">Month</b-dropdown-item>
                <b-dropdown-item @click="selectedDuration = 180; selectedDurationStr = 'HalfYear'">6
                    Months</b-dropdown-item>
                <b-dropdown-item @click="selectedDuration = 365; selectedDurationStr = 'Year'">Year</b-dropdown-item>
            </b-dropdown>
            <button type="submit" class="button-main">Create voucher codes</button>
        </form>

        <div v-if="message" class="message">{{ message }}</div>

        <div v-if="newvouchers" class="newvouchers">
            <ul>
                <li v-for="voucher in newvouchers" :key="voucher">{{ voucher }}</li>
            </ul>
        </div>

        <br />
        <h2>Vouchers</h2>

        <b-dropdown id="type-filter-select" :text="filteredTypeStr || 'Filter by subscription type'"
            class="m-md-2">
            <b-dropdown-item @click="filteredType = 'test'; filteredTypeStr = 'Test'; $event.target.blur(); refresh();">Test</b-dropdown-item>
            <b-dropdown-item @click="filteredType = 'free'; filteredTypeStr = 'Free'; $event.target.blur(); refresh();">Free</b-dropdown-item>
            <b-dropdown-item @click="filteredType = 'plus'; filteredTypeStr = 'Plus'; $event.target.blur(); refresh();">Plus</b-dropdown-item>
            <b-dropdown-item @click="filteredType = 'ai'; filteredTypeStr = 'AI'; $event.target.blur(); refresh();">AI</b-dropdown-item>
            <b-dropdown-item @click="filteredType = 'plusai'; filteredTypeStr = 'Plus and AI'; $event.target.blur(); refresh();">Plus &amp; AI</b-dropdown-item>

            <b-dropdown-item v-for="elem in additionalTypes" v-bind:key="'filter-'+ elem" @click="filteredType = elem; filteredTypeStr = elem; $event.target.blur(); refresh();">{{ elem }}</b-dropdown-item>
        </b-dropdown>
            
        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Claimed by user (if any)</th>
                    <th>Type</th>
                    <th>Duration (days)</th>
                    <th>Expires</th>
                    <th>Last renewed</th>
                    <th>Shopify Order</th>
                    <th>Shopify Customer</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="voucher in vouchers" :key="voucher.id">
                    <td>{{ voucher.id }}</td>
                    <td>{{ voucher.code }}</td>
                    <td><router-link :to="{ name: 'UserDetailView', params: { id: voucher.userId || 0 } }">{{
                    voucher.userId }}</router-link></td>
                    <td>{{ voucher.subscriptionType }}</td>
                    <td>{{ voucher.durationDays }}</td>
                    <td>{{ formatDate(voucher.expiresAt) }}</td>
                    <td>{{ formatDate(voucher.renewedAt) }}</td>
                    <td>{{ voucher.shopifyOrderName }}</td>
                    <td>{{ voucher.shopifyCustomerEmail }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { fetchVouchers, createVouchers } from '@/repository/apiService';

export default {
    data() {
        return {
            vouchers: [],
            newvouchers: [],
            message: '',
            success: false,
            selectedDuration: null,
            selectedDurationStr: null,
            selectedType: null,
            selectedTypeStr: null,
            filteredType: 'test',
            filteredTypeStr: 'Test',

            additionalTypes: [
    'pocket-acute',
    'pocket-allergo',
    'pocket-cardio',
    'pocket-derma',
    'pocket-diagnos',
    'pocket-endocrino',
    'pocket-ent',
    'pocket-epidemio',
    'pocket-ethics',
    'pocket-family',
    'pocket-firstaid',
    'pocket-gastroenter',
    'pocket-gastroint',
    'pocket-genetics',
    'pocket-geria',
    'pocket-heama',
    'pocket-law',
    'pocket-microbio',
    'pocket-molecular',
    'pocket-minsurge',
    'pocket-nephro',
    'pocket-neuro',
    'pocket-obst',
    'pocket-onco',
    'pocket-ooghk',
    'pocket-opthalmo',
    'pocket-ortho',
    'pocket-paedia',
    'pocket-pallzorg',
    'pocket-pharma',
    'pocket-plastic',
    'pocket-preventive',
    'pocket-psych',
    'pocket-pulmo',
    'pocket-radio',
    'pocket-rheuma',
    'pocket-trauma',
    'pocket-uro',
    'pocket-vascular',
    'pocket-nl-acute',
    'pocket-nl-allergo',
    'pocket-nl-cardio',
    'pocket-nl-derma',
    'pocket-nl-diagnos',
    'pocket-nl-endocrino',
    'pocket-nl-ent',
    'pocket-nl-epidemio',
    'pocket-nl-ethics',
    'pocket-nl-family',
    'pocket-nl-firstaid',
    'pocket-nl-gastroenter',
    'pocket-nl-gastroint',
    'pocket-nl-genetics',
    'pocket-nl-geria',
    'pocket-nl-heama',
    'pocket-nl-law',
    'pocket-nl-microbio',
    'pocket-nl-molecular',
    'pocket-nl-minsurge',
    'pocket-nl-nephro',
    'pocket-nl-neuro',
    'pocket-nl-obst',
    'pocket-nl-onco',
    'pocket-nl-opthalmo',
    'pocket-nl-ortho',
    'pocket-nl-paedia',
    'pocket-nl-pallzorg',
    'pocket-nl-pharma',
    'pocket-nl-plastic',
    'pocket-nl-preventive',
    'pocket-nl-psych',
    'pocket-nl-pulmo',
    'pocket-nl-radio',
    'pocket-nl-rheuma',
    'pocket-nl-trauma',
    'pocket-nl-uro',
    'pocket-nl-vascular',
            ]
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        async refresh() {
            try {
                this.vouchers = await fetchVouchers(this.filteredType);
            } catch (error) {
                console.error('Error fetching vouchers:', error);
            }
        },
        async submitForm() {
            try {
                const response = await createVouchers(100, this.selectedType, this.selectedDuration);
                this.message = response.success ? 'Created successfully! Copy-paste these codes:' : 'Error: ' + response.message;
                console.log(response);
                this.newvouchers = response.data;
                setTimeout(this.refresh, 1000);
            } catch (error) {
                this.message = error.message;
            }
        },
        formatDate(date) {
            if (date) {
                return (new Date(date)).toLocaleString();
            }
            return '';
        }
    }
};
</script>

<style>
.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10pt;
}

.table th,
.table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.table th {
    background-color: #f4f4f4;
}
</style>
